module.exports = __webpack_public_path__ + "img/edge_activites_en_famille.f8bd9fc0.svg";